export enum TransferType {
  DOWNLOAD = 10,
  UPLOAD = 20,
  FOLDER_UPLOAD = 30,
  PREVIEW = 50,
}
